export interface RegionLiceReportWeekCandidate {
    isoWeek: number;
    isoYear: number;
}

/**
 * The week a region report opens on. Newest first.
 *
 * The week list always includes the running week, even when that week has no rows. Once the
 * fetch comes back empty, `skipKeys` drops it so the next entry — the newest saved report —
 * is the one the page opens on. A running week that has rows is not in `skipKeys`.
 */
export function defaultRegionLiceReportWeek<T extends RegionLiceReportWeekCandidate>(
    weeks: readonly T[],
    skipKeys: ReadonlySet<string>
): T | undefined {
    return weeks.find((week) => !skipKeys.has(`${week.isoWeek}-${week.isoYear}`));
}
